import { ImSpinner9 } from "react-icons/im";
import { TailSpin } from "react-loader-spinner";
import "../styles/loading.css";

export default function Spinner({ size = 16 }) {
  return (
    <div style={{ display: "flex", flex: 1 }}>
      <TailSpin
        ariaLabel="loading-indicator"
        height={24}
        width={24}
        color="#acd732"
      />
    </div>
  );
}
